module.exports = __webpack_public_path__ + "img/Xiaochun_Cao@2x.22bb9b19.png";